export default __webpack_public_path__ + "static/media/placeholder_portfolio04-en-web.0c0036cb.png";